export default __webpack_public_path__ + "static/media/logo-background1.0ef0eaa6.png";